import styled from "styled-components";
import { BotaoEnviar } from "../Botoes";
import React, { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import { useForm } from "react-hook-form";
import Estados from "./Estados";
import Cidades from "./Cidades";
import Cargos from "./Cargos";
import { formatarCelular } from "../../utils/formatarCelular";
import formatarCPFCNPJTempoReal from "../../utils/formatarCNPJCPF";
import axios from "axios";
import { toast } from "react-toastify";

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  font-size: var(--smaller-font);
  font-weight: var(--regular-weight);
  display: flex;
  flex-direction: column;
  padding: 2em 2em;
  gap: 0.6em;
  background-color: ${(props) => props.$bgcolor || "rgb(15, 50, 100)"};
  border-radius: var(--border-radius-s);
  width: 100%;

  .error {
    background-color: #fee2e2 !important;
  }

  @media screen and (min-width: 650px) {
    width: 65vw;
    max-width: 600px;
  }
`;

const InputLabel = styled.label`
  padding: 0 0 0.2em 0.7em;
  color: white;
  text-align: center;
  width: 100%;
`;

const Campo = styled.input`
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 0.4em;
  color: ${(props) => props.$color || "black"};
  background-color: ${(props) => props.$color || "white"};
`;

const Option = styled.option`
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 0.4em;
  color: ${(props) => props.$color || "black"};
  background-color: ${(props) => props.$color || "white"};
`;

const Select = styled.select`
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 0.4em;
  color: ${(props) => props.$color || "black"};
  background-color: ${(props) => props.$color || "white"};

  &:disabled {
    background-color: #f0f0f0;
    color: #a0a0a0;
    cursor: not-allowed;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 0.4em;
  color: ${(props) => props.$color || "black"};
  background-color: ${(props) => props.$color || "white"};
`;

const Title = styled.h1`
  font-weight: var(--strong-weight);
  font-size: var(--bigger-font);
  text-align: left;
  color: ${(props) => props.$color || "black"};
`;

const Subtitle = styled.h2`
  text-align: ${(props) => props.$align || "center"};
  font-weight: var(--weak-weight);
  font-size: ${(props) => props.$size || "var(--small-font)"};
  color: ${(props) => props.$color || "black"};
`;

const Espacador = styled.div`
  width: 100%;
  height: 1em;
  background: transparent;
`;

export default function Form({
  titulo,
  subtitulo,
  sejaParceiro,
  formProduto,
  nomeProduto,
  color,
  $bgcolor,
  trabalheConosco,
  faleConosco,
  refs,
}) {
  const {
    register,
    watch,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const watchEstado = watch("estado");
  const [cityIndex, setCityIndex] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Erro ao enviar mensagem");
  const [sourceFile, setSourceFile] = useState(null);
  const route = formProduto === true ? "/send-lead" : "/send-email";
  const tipo = formProduto === true ? `Produto ${nomeProduto}` : titulo;

  useEffect(() => {
    if (watchEstado) {
      const state = Estados.find((x) => x.sigla === watchEstado);
      const stateIndex = state.index;
      setCityIndex(stateIndex);
      setValue("cidade", "");
    }
  }, [watchEstado]);

  const onSubmit = (data) => {
    submitProduto(data);
  };

  function submitProduto(data) {
    let {
      nomeUsuario,
      email,
      whatsapp,
      nomeEmpresa,
      cnpj,
      cnae,
      razaoSocial,
      estado,
      cidade,
      receberEmail,
      mensagem,
      cargo,
    } = data;

    if (formProduto) {
      let request = {
        empresa: nomeEmpresa,
        cliente: nomeUsuario,
        email: email,
        segmento: cnae,
        telefone: whatsapp?.replace(/\D/g, ""),
        cidade: cidade,
        estado: estado,
        cnpj: cnpj?.replace(/\D/g, ""),
        adquirente: nomeUsuario,
        cargo: cargo,
      };

      let mensagem = `Enviado do produto ${nomeProduto}.`;

      request.mensagem = mensagem;

      let promise = axios
        .post("https://flowdesk.com.br/api/v1/integracoes/lead", request, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic cG8wMUBzaWZhdC5jb20uYnI6U2Z0MTg1NDI2IQ==",
            token:
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.W10.C5CaY5fbzjL9shURDSA8uM8PF0O2dJyZvoBlIGi7bgw",
          },
        })
        .then((response) => {
          console.log("Formulário enviado com sucesso!", response);
          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
          }, 4000);
          return response.data;
        })
        .catch((error) => {
          console.error("Erro ao enviar formulário:", error);
          throw error;
        });

      toast.promise(promise, {
        pending: "Enviando formulário...",
        success: "Formulário enviado com sucesso!",
        error: "Erro ao enviar formulário.",
      });
    }

    if (faleConosco || sejaParceiro || trabalheConosco) {
      let request = {
        nome: nomeUsuario,
        email: email,
        telefone: whatsapp,
        mensagem: `${estado ? `<strong>Estado:</strong> ${estado}<br>` : ""}
        ${cidade ? `<strong>Cidade:</strong> ${cidade}<br>` : ""}
        ${cnpj ? `<strong>CNPJ:</strong> ${cnpj}<br>` : ""}
        ${
          razaoSocial ? `<strong>Razão Social:</strong> ${razaoSocial}<br>` : ""
        }
        ${cnae ? `<strong>CNAE:</strong> ${cnae}<br>` : ""}
        <strong>Aceitou receber e-mails:</strong> ${
          receberEmail ? "Sim" : "Não"
        }<br>
        ${mensagem ? `<strong>Mensagem:</strong> ${mensagem}<br>` : ""}
        `,
      };

      if (faleConosco) {
        let promise = axios
          .post(
            "https://emailsitesifat.waybe.com.br/api/formularios/seja-parceiro",
            request,
          )
          .then((response) => {
            console.log("Formulário enviado com sucesso!", response.data);
            return response.data;
          })
          .catch((error) => {
            console.error("Erro ao enviar formulário:", error);
            throw error;
          });

        toast.promise(promise, {
          pending: "Enviando formulário...",
          success: "Formulário enviado com sucesso!",
          error: "Erro ao enviar formulário.",
        });
      }

      if (trabalheConosco) {
        let payload;
        const file = sourceFile
          ? new File([sourceFile], sourceFile.name, {
              type: sourceFile.type,
              lastModified: sourceFile.lastModified || Date.now(),
            })
          : null;
        if (file) {
          const formData = new FormData();
          formData.append("arquivo", file);
          payload = formData;
        }
        let promise = axios
          .post(
            `https://emailsitesifat.waybe.com.br/api/formularios/trabalhe-conosco?nome=${encodeURIComponent(
              request.nome,
            )}&email=${encodeURIComponent(
              request.email,
            )}&telefone=${encodeURIComponent(
              request.telefone,
            )}&mensagem=${encodeURIComponent(request.mensagem)}`,
            payload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((response) => {
            console.log("Formulário enviado com sucesso!", response.data);
            reset();
            return response.data;
          })
          .catch((error) => {
            console.error("Erro ao enviar formulário:", error);
            throw error;
          });

        toast.promise(promise, {
          pending: "Enviando formulário...",
          success: "Formulário enviado com sucesso!",
          error: "Erro ao enviar formulário.",
        });
      }
      if (sejaParceiro) {
        const file = sourceFile
          ? new File([sourceFile], sourceFile.name, {
              type: sourceFile.type,
              lastModified: sourceFile.lastModified || Date.now(),
            })
          : null;
        let payload;

        if (file) {
          const formData = new FormData();
          formData.append("arquivo", file, file.name);
          payload = formData;
        }
        let promise = axios
          .post(
            `https://emailsitesifat.waybe.com.br/api/formularios/seja-parceiro?nome=${encodeURIComponent(
              request.nome,
            )}&email=${encodeURIComponent(
              request.email,
            )}&telefone=${encodeURIComponent(
              request.telefone,
            )}&mensagem=${encodeURIComponent(request.mensagem)}`,
            payload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((response) => {
            console.log("Formulário enviado com sucesso!", response.data);
            setShowSuccess(true);
            setTimeout(() => {
              setShowSuccess(false);
            }, 4000);
            return response.data;
          })
          .catch((error) => {
            console.error("Erro ao enviar formulário:", error);
            throw error;
          });

        toast.promise(promise, {
          pending: "Enviando formulário...",
          success: "Formulário enviado com sucesso!",
          error: "Houve um erro ao enviar formulário.",
        });
      }
    }
  }

  const watchFile = watch("anexo");

  useEffect(() => {
    if (watchFile && watchFile.length > 0) {
      handleFileChange({ target: { files: watchFile } });
    }
  }, [watchFile]);

  function handleFileChange(e) {
    const file = e.target.files[0];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const MAX_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

    if (file && !allowedTypes.includes(file.type)) {
      alert("Tipo de arquivo não permitido.");
      setValue("anexo", null);
      setSourceFile(null);
      return;
    }

    const validExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".docx"];
    const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

    if (!validExtensions.includes(ext)) {
      toast.error("Extensão não permitida.");
      setValue("anexo", null);
      setSourceFile(null);
      return;
    }

    if (file && file.size > MAX_SIZE_BYTES) {
      const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
      toast.error(`Arquivo muito grande (${sizeMB}MB). Limite: 5MB.`);
      setValue("anexo", null);
      setSourceFile(null);
      return;
    }
    setSourceFile(file);
  }

  return (
    <>
      <Title $color={color}>{titulo}</Title>
      <Subtitle $color={color}>{subtitulo}</Subtitle>

      <FormContainer
        ref={refs}
        $bgcolor={$bgcolor}
        onSubmit={handleSubmit(onSubmit)}
        encType={"multipart/form-data"}
      >
        <div>
          <InputLabel htmlFor="nomeUsuario">
            Nome: <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Campo
            type="text"
            name="nomeUsuario"
            id="nomeUsuario"
            placeholder="Como gostaria de ser chamado?"
            {...register("nomeUsuario", { pattern: /^[A-Za-zÀ-ÿ\s]+$/ })}
            maxLength={"30"}
            required
            aria-invalid={errors.nomeUsuario ? "true" : "false"}
          />
          {errors.nomeUsuario?.type === "pattern" && (
            <p role="alert" className="badge text-bg-danger fw-normal fs-6 m-0">
              Use apenas letras!
            </p>
          )}
        </div>

        {formProduto && (
          <div>
            <InputLabel htmlFor="cargo">
              Cargo <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select name="cargo" id="cargo" {...register("cargo")} required>
              <Option value={""}>Qual seu cargo?</Option>
              {Cargos.map((cargo, index) => (
                <Option key={index} value={cargo}>
                  {cargo}
                </Option>
              ))}
            </Select>
          </div>
        )}

        {formProduto && (
          <>
            <div>
              <InputLabel htmlFor="nomeEmpresa">
                Nome da empresa: <span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Campo
                type="text"
                name="nomeEmpresa"
                id="nomeEmpresa"
                placeholder="Qual o nome da empresa?"
                {...register("nomeEmpresa", {
                  pattern: /^[A-Za-zÀ-ÿ0-9\s.&-]+$/,
                })}
                maxLength={"30"}
                required
                aria-invalid={errors.nomeEmpresa ? "true" : "false"}
              />
              {errors.nomeEmpresa?.type === "pattern" && (
                <p
                  role="alert"
                  className="badge text-bg-danger fw-normal fs-6 m-0"
                >
                  Use apenas: letras, números, "-", "." ou "&"
                </p>
              )}
            </div>
          </>
        )}

        <div>
          <InputLabel htmlFor="email">
            E-mail: <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Campo
            type="email"
            name="email"
            id="email"
            placeholder="Ex.: nome@email.com"
            {...register("email")}
            maxLength={"44"}
            required
          />
        </div>
        <div>
          <InputLabel htmlFor="telefone">
            WhatsApp: <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Campo
            type="tel"
            name="whatsapp"
            id="whatsapp"
            placeholder="Ex.: (17) 00000-0000"
            {...register("whatsapp")}
            maxLength={"18"}
            onChange={(e) => {
              const formattedValue = formatarCelular(e.target.value);
              setValue("whatsapp", formattedValue);
            }}
            minLength={"8"}
            required
            aria-invalid={errors.whatsapp ? "true" : "false"}
          />
          {errors.whatsapp?.type === "pattern" && (
            <p role="alert" className="badge text-bg-danger fw-normal fs-6 m-0">
              Use apenas números
            </p>
          )}
        </div>

        {(sejaParceiro || faleConosco) && (
          <>
            {sejaParceiro && (
              <>
                <Espacador />

                <Subtitle
                  $color={"white"}
                  $align={"center"}
                  $size={"var(--medium-font)"}
                >
                  Dados da empresa
                </Subtitle>
              </>
            )}

            <div>
              <InputLabel htmlFor="cnpj">CNPJ:</InputLabel>
              <Campo
                type="text"
                name="cnpj"
                id="cnpj"
                {...register("cnpj")}
                maxLength={"18"}
                minLength={"18"}
                placeholder="Ex.: 00.000.000/0000-00"
                onChange={(e) => {
                  let cnpj = formatarCPFCNPJTempoReal(e.target.value, "cnpj");
                  setValue("cnpj", cnpj);
                }}
              />
              {errors.cnpj?.type === "pattern" && (
                <p
                  role="alert"
                  className="badge text-bg-danger fw-normal fs-6 m-0"
                >
                  Use apenas números
                </p>
              )}
            </div>

            {sejaParceiro && (
              <>
                <div>
                  <InputLabel htmlFor="cnae">CNAE:</InputLabel>
                  <Campo
                    type="text"
                    name="cnae"
                    id="cnae"
                    placeholder="Digite seu CNAE"
                    {...register("cnae")}
                    maxLength={"15"}
                  />
                </div>
                <div>
                  <InputLabel htmlFor="razaoSocial">Razão Social:</InputLabel>
                  <Campo
                    type="text"
                    name="razaoSocial"
                    id="razaoSocial"
                    placeholder="Digite sua Razão Social"
                    {...register("razao", {
                      pattern: /^[A-Za-zÀ-ÿ0-9\s.&-]+$/,
                    })}
                    maxLength={"30"}
                  />
                  {errors.razao?.type === "pattern" && (
                    <p
                      role="alert"
                      className="badge text-bg-danger fw-normal fs-6 m-0"
                    >
                      Use apenas: letras, números, "-", "." ou "&"
                    </p>
                  )}
                </div>
              </>
            )}
          </>
        )}

        {!trabalheConosco && (
          <>
            <div>
              <InputLabel htmlFor="estado">
                Estado <span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Select
                name="estado"
                id="estado"
                {...register("estado")}
                required
              >
                {Estados.map((estado, index) => (
                  <Option key={index} value={estado.sigla}>
                    {estado.nome}
                  </Option>
                ))}
              </Select>
            </div>
            <div>
              <InputLabel htmlFor="cidade">
                Cidade <span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Select
                name="cidade"
                id="cidade"
                disabled={!watchEstado}
                {...register("cidade")}
                required
              >
                <Option value={""}>{"Selecione uma cidade"}</Option>
                {Cidades[cityIndex]?.map((cidade, index) => (
                  <Option key={index} value={cidade}>
                    {cidade}
                  </Option>
                ))}
              </Select>
            </div>
          </>
        )}

        {trabalheConosco && (
          <>
            <div>
              <InputLabel htmlFor="anexo">
                Anexar currículo (.pdf)<span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Campo
                type="file"
                name="anexo"
                id="anexo"
                accept="image/jpeg,image/png,application/pdf,.docx"
                required
                {...register("anexo")}
              />
            </div>
            <div>
              <InputLabel htmlFor="mensagem">Mensagem</InputLabel>
              <TextArea
                name="mensagem"
                id="mensagem"
                placeholder="Digite aqui sua mensagem."
                rows="4"
                maxLength={"250"}
                {...register("mensagem")}
              />
            </div>
          </>
        )}

        {sejaParceiro && (
          <>
            <InputLabel htmlFor="anexo">
              Caso queira se antecipar enviando documento (.pdf) da empresa,
              clique abaixo:
            </InputLabel>

            <Campo
              type="file"
              name="anexo"
              id="anexo"
              accept="image/jpeg,image/png,application/pdf,.docx"
              {...register("anexo")}
            />
          </>
        )}

        <InputLabel htmlFor="receberNovidades">
          <input
            type="checkbox"
            name="receberNovidades"
            id="receberNovidades"
            style={{ margin: "0 0.5em 0 0" }}
            {...register("receberNovidades")}
          />
          Quero receber e-mails e mensagens sobre produtos e novidades da SIFAT.
        </InputLabel>

        <InputLabel>
          Campos com asterisco (<span style={{ color: "red" }}>*</span>) são
          obrigatórios!
        </InputLabel>

        <Espacador />

        <Alert variant={"success"} show={showSuccess}>
          Dados enviados!
        </Alert>

        <Alert variant={"danger"} show={showError}>
          {errorMessage}
        </Alert>

        <BotaoEnviar />
      </FormContainer>
    </>
  );
}
